import { request as sonataRequest } from 'sonata-react-components';
import { getSonataSession } from 'sonata-static-storage/lib/helpers/session.helpers';

export function getMacrosFile(
  countries: string[] | undefined,
  entityId: string,
  macrosData: any,
  type: string | undefined,
  token: string
) {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}macros/macrosList`,
    {
      data: {
        campaignId: entityId,
        countries,
        macrosData,
        type
      },
      headers: getSonataSession(),
      method: 'POST'
    },
    token
  );
}

export function getMacros(countries: string[], ids: string[], type: string, token: string) {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}macros`,
    {
      headers: getSonataSession(),
      method: 'GET',
      params: {
        countries,
        ids,
        type
      }
    },
    token
  );
}

export function getCampaignMacrosStatuses(campaignId: string, ids: string, token: string) {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}macros/${campaignId}/statuses`,
    {
      headers: getSonataSession(),
      method: 'GET',
      params: {
        ids
      }
    },
    token
  );
}
